import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThirdPartyClaimState {
  typeOfGuest: TypeOfGuest;
  policyNumber: string;
}

export enum TypeOfGuest {
  NONE = '',
  INSURED = 'insured',
  INSURANCE_REP = 'rep',
}

const initialState: ThirdPartyClaimState = {
  typeOfGuest: TypeOfGuest.NONE,
  policyNumber: '',
};

const thirdPartyClaimSlice = createSlice({
  name: 'thirdPartyClaim',
  initialState,
  reducers: {
    updateTypeOfGuest(state, action: PayloadAction<{ typeOfGuest: TypeOfGuest }>) {
      state.typeOfGuest = action.payload.typeOfGuest;
    },
    updatePolicyInfo(state, action: PayloadAction<{ policyNumber: string }>) {
      state.policyNumber = action.payload.policyNumber;
    },
  },
});

export const { updateTypeOfGuest, updatePolicyInfo } = thirdPartyClaimSlice.actions;
export default thirdPartyClaimSlice.reducer;
